module.exports = __webpack_public_path__ + "static/media/pulverizador2.25667ab5.svg";